import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MessageOutlined } from '@ant-design/icons';
import { Descriptions, Divider, Drawer, Table, Tooltip, Col } from 'antd';
import moment from "moment";
import { When } from "react-if";
import { useMediaQuery } from 'usehooks-ts';

import { RootState } from "../../store";
import { AttendanceTypes } from "../../types/attendance.types";
import { ModalChatViewer } from "../modal-chat-viewer";
import { departmentService } from "../../services/department.service";
import { DepartmentTypes } from "../../types";

export const DepartmentDetailsDrawer = () => {
    const isSmallScreen = useMediaQuery('(max-width: 768px)');

    const { modal, loading, department, departmentAttendancesPagination } = useSelector((state: RootState) => state.department);

    const [selectedAttendance, setSelectedAttendance] = useState<AttendanceTypes.Model>({} as AttendanceTypes.Model);
    const [viewChatModalVisible, setViewChatModalVisible] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
    });

    const onClose = () => {
        departmentService.dispatch.setDepartment({} as DepartmentTypes.Model);
        departmentService.dispatch.toggleModal('details', false);
    }

    const onChangePagination = (page: number, perPage: number) => {
        setPagination({ page, perPage });
    }

    useEffect(() => {
        if (Object.values(department)?.length > 0 && modal.details) {
            departmentService.fetchAttendancesByDepartment({ ...pagination, filter: {} as AttendanceTypes.Filters }, department.id, (isValid, msg) => {});
        }
    }, [modal.details, department, pagination]);

    return (
        <>
            <Drawer
                title={'Detalhes do departmento'}
                placement={'right'}
                open={modal.details}
                onClose={onClose}
                width={isSmallScreen ? '90vw' : 650}
            >
                <Descriptions column={2} size='default' layout='vertical'>
                    <Descriptions.Item span={1} label="Identificador" labelStyle={{ fontWeight: 600 }}>
                        {department?.id}
                    </Descriptions.Item>
                    <Descriptions.Item label="Nome" labelStyle={{ fontWeight: 600 }}>
                        {department?.name}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Data de criação" labelStyle={{ fontWeight: 600 }}>
                        {moment(department?.createdAt).format('DD/MM/YYYY hh:mm')}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Última atualização" labelStyle={{ fontWeight: 600 }}>
                        {moment(department?.updatedAt).format('DD/MM/YYYY hh:mm')}
                    </Descriptions.Item>
                </Descriptions>
                
                <Divider />

                <Descriptions title="Atendimentos" style={{ marginTop: 15, marginBottom: -10 }} />

                <div className="table-responsive">
                    <Table 
                        columns={[
                            {
                                title: 'Protocolo',
                                render: (_, att) => <strong># {att.protocol}</strong> 
                            },
                            {
                                title: 'Atendente',
                                render: (_, att) => <>{att?.user?.name}</> 
                            },
                            {
                                title: 'Data de criação',
                                dataIndex: 'createdAt',
                                render: (_, att) => moment(att.createdAt).format('DD/MM/YYYY HH:mm')
                            },
                            {
                                title: 'Ações',
                                dataIndex: 'actions',
                                render: (_, att) => (
                                    <div className="text-center"> 
                                        <Tooltip placement="topLeft" title="Visualizar atendimento">
                                            <MessageOutlined 
                                                size={48}
                                                onClick={() => {
                                                    setSelectedAttendance(att);
                                                    setViewChatModalVisible(true);
                                                }}
                                            />
                                        </Tooltip>
                                    </div>
                                )
                            }
                        ]} 
                        locale={{
                            emptyText: <Col style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                
                                <span>{'Aparentemente este departamento não possui nenhum atendimento.'}</span>
                            </Col>,
                            
                        }}
                        loading={loading.fetchAttendancesByDepartment}
                        dataSource={departmentAttendancesPagination?.items} 
                        pagination={{
                            pageSize: pagination.perPage,
                            total: departmentAttendancesPagination?.total,
                            defaultCurrent: 1,
                            onChange: onChangePagination
                        }}
                    />
                </div>
            </Drawer>

            <When condition={viewChatModalVisible}>
                <ModalChatViewer 
                    selectedAttendance={selectedAttendance}
                    visible={viewChatModalVisible}
                    onClose={() => {
                        setSelectedAttendance({} as AttendanceTypes.Model);
                        setViewChatModalVisible(false);
                    }}
                />
            </When>
        </>
    )

}